// Recovered compiled webpack factory 77319. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { MarketingLink: () => d, w: () => c });
  var r = a(95155),
    n = a(52619),
    i = a.n(n),
    s = a(20063),
    o = a(12115);
  let l = (0, o.createContext)(null);
  function c(e) {
    let { children: t } = e,
      [a, n] = (0, o.useState)(null),
      i = (0, o.useRef)(null),
      s = (0, o.useRef)(null),
      c = (0, o.useCallback)(
        () => (
          s.current ||
            (s.current = fetch("/api/auth/session", { cache: "no-store" })
              .then(async (e) => {
                var t;
                if (!e.ok) throw Error("Session unavailable");
                let a = await e.json(),
                  r = (null == a || null == (t = a.user) ? void 0 : t.id) ? "/home" : "/";
                return (n(r), r);
              })
              .catch(() => (n("/home"), "/home"))),
          s.current
        ),
        [],
      );
    return (
      (0, o.useEffect)(() => {
        c();
      }, [c]),
      (0, r.jsx)(l.Provider, { value: { homePath: a, resolveHome: c, frame: i }, children: t })
    );
  }
  function d(e) {
    let { href: t, onClick: a, ...n } = e,
      c = (0, o.useContext)(l),
      d = (0, s.usePathname)(),
      m = (0, s.useRouter)(),
      u = (0, o.useRef)(null),
      h = (null == c ? void 0 : c.frame) ?? u;
    (0, o.useEffect)(
      () => () => {
        null !== h.current && cancelAnimationFrame(h.current);
      },
      [d, h],
    );
    let p = "string" == typeof t && /^\/(?:home)?(?:#.*)?$/.test(t),
      f = p && "string" == typeof t ? t.slice(0 > t.indexOf("#") ? t.length : t.indexOf("#")) : "",
      x = "/" === d || "/home" === d,
      g = x ? d : ((null == c ? void 0 : c.homePath) ?? "/");
    return (0, r.jsx)(i(), {
      ...n,
      href: p ? `${g}${f}` : t,
      prefetch: !p && n.prefetch,
      onClick: async (e) => {
        var t;
        if (
          (null == a || a(e),
          !p ||
            e.defaultPrevented ||
            0 !== e.button ||
            e.metaKey ||
            e.ctrlKey ||
            e.shiftKey ||
            e.altKey ||
            "_blank" === n.target)
        )
          return;
        if (!x) {
          e.preventDefault();
          let t = c ? await c.resolveHome() : "/";
          m.push(`${t}${f}`);
          return;
        }
        let r = e.currentTarget.closest("main"),
          i = f ? document.getElementById(f.slice(1)) : null;
        if (!r || (f && !i)) return;
        (e.preventDefault(), null !== h.current && cancelAnimationFrame(h.current));
        let s = (null == (t = r.querySelector("[data-sticky-nav]")) ? void 0 : t.offsetHeight) ?? 0,
          o = Math.max(
            0,
            Math.min(
              i
                ? r.scrollTop +
                    i.getBoundingClientRect().top -
                    r.getBoundingClientRect().top -
                    s -
                    12
                : 0,
              r.scrollHeight - r.clientHeight,
            ),
          );
        if (
          (history.replaceState(history.state, "", `${d}${location.search}${f}`),
          matchMedia("(prefers-reduced-motion: reduce)").matches)
        ) {
          r.scrollTop = o;
          return;
        }
        let l = r.scrollTop,
          u = null,
          g = (e) => {
            u ??= e;
            let t = Math.min(1, (e - u) / 460);
            ((r.scrollTop =
              l + (o - l) * (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)),
              (h.current = t < 1 ? requestAnimationFrame(g) : null));
          };
        h.current = requestAnimationFrame(g);
      },
    });
  }
}
